import styles from './StateHeader.module.scss'
import DefaultBreadcrumbs from '../../../components/Breadcrumbs/DefaultBreadcrumbs'


const Header = ({ headerType, geo_id }) => {
  return (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          <DefaultBreadcrumbs
            geo_id={geo_id}
            geo_type={headerType}
            dashboardType={'birthtrend'}
          />
        
        </div>
      </div>
    </>
  )
}
export default Header
